import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import SubmitButton from "../../forms/submit-button/SubmitButton";
class ClosedMessageFooter extends PureComponent {
  render() {
    const {
      onButtonClick,
      classes
    } = this.props;
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.closedMessageContainer
    }, onButtonClick && /*#__PURE__*/React.createElement("div", {
      className: classes.newConversationButton
    }, /*#__PURE__*/React.createElement(SubmitButton, {
      disabled: false,
      id: "newConversationButton",
      title: "New Conversation",
      handleSubmit: onButtonClick,
      loading: false,
      containerEnabled: false,
      staticButton: true
    }))));
  }
}
const styles = {
  closedMessageContainer: {
    minHeight: 54,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    height: "0px"
  },
  newConversationButton: {
    flex: "3 0 0",
    textAlign: "center"
  }
};
export default withStyles(styles)(ClosedMessageFooter);
ClosedMessageFooter.propTypes = {
  message: PropTypes.object.isRequired,
  onButtonClick: PropTypes.func,
  classes: PropTypes.object.isRequired
};